import dictionary from './wordLists/dictionary'
import possibleWords from './wordLists/possibleWords'


function  generatePuzzle(maxGreen, maxYellow, wordLength) {
  wordLength = parseInt(wordLength);
  const numGuesses = 3
  const allWords = dictionary.split('\n').filter((word) => word.length === wordLength);
  const allowedWords = possibleWords.split('\n').filter((word) => word.length === wordLength);
  const startTime = Date.now();
  let response;
  while (true) {
    let guesses = ['', '', ''];
    let target = '';
    while (guesses[0] === guesses[1] || guesses[1] === guesses[2] || guesses[0] === guesses[2] || guesses.includes(target)) {
      guesses[0] = allowedWords[Math.floor(Math.random() * allowedWords.length)].toUpperCase();
      guesses[1] = allowedWords[Math.floor(Math.random() * allowedWords.length)].toUpperCase();
      guesses[2] = allowedWords[Math.floor(Math.random() * allowedWords.length)].toUpperCase();
      target = allowedWords[Math.floor(Math.random() * allowedWords.length)].toUpperCase();
    }
    
    let green = '-'.repeat(wordLength);
    const yellow = new Map();
    let grey = [];

    for (const letter of target) {
      yellow.set(letter, new Array(numGuesses).fill(0));
    }

    guesses.forEach((guess, i) => {
      const count = new Map();
      for (const letter of target) {
        count.set(letter, count.get(letter) ?? 0 + 1);
      }

      // Calculates greens
      for (let j = 0; j < wordLength; j++) {
        if (guess[j] === target[j]) {
          green = green.substring(0, j) + guess[j] + green.substring(j + 1);
          count.set(guess[j], count.get(guess[j] - 1));
        }
      }

      // Calculates yellows
      for (let j = 0; j < wordLength; j++) {
        if (count.has(guess[j]) && count.get(guess[j]) > 0 && guess[j] !== target[j]) {
          count.set(guess[j], count.get(guess[j] - 1));
          yellow.get(guess[j])[i]++;
        } else if (!target.includes(guess[j]) && !grey.includes(guess[j])) {
          grey.push(guess[j]);
        }
      }
    });

    for (const letter of target) {
      yellow.set(letter, Math.max(yellow.get(letter)));
    }

    // Test puzzle matches set conditions
    let numGreen = green.replaceAll('-', '').length;
    let numYellow = 0
    yellow.forEach((v) => {
      numYellow += v;
    }); 
    if (numGreen > maxGreen || numYellow + numGreen > maxYellow + maxGreen) {
      continue;
    }

    // Test puzzle has unique solution
    let matches = 0;
    let skip;
    for (let word of allWords) {
      word = word.toUpperCase();
      skip = false;

      for(const letter of word) {
        if (grey.includes(letter)) {
          skip = true;
          break;
        }
      }
      if (skip) {
        continue;
      }

      for (let i = 0; i < wordLength; i++) {
        if (green[i] !== word[i] && green[i] !== '-') {
          skip = true;
          break;
        }
      }
      if (skip) {
        continue;
      }

      for (let [letter, number] of yellow) {
        if (wordLength - word.replaceAll(letter, '') < number) {
          skip = true;
          break;
        }
      }
      if (skip) {
        continue;
      }

      matches++;
      if (matches > 1) {
        break;
      }
    }

    if (matches === 1) {
      response = {'guesses': guesses, 'target': target};
      break;
    } else if (Date.now() - startTime > 10000) {
      response = {'guesses': [], 'target': '', 'error': 'Parameters too restrictive'};
      break;
    }
  }
  
  return response;
}

export default generatePuzzle;